import { render, staticRenderFns } from "./RightPartMessage.vue?vue&type=template&id=5a77a852&scoped=true"
import script from "./RightPartMessage.vue?vue&type=script&lang=js"
export * from "./RightPartMessage.vue?vue&type=script&lang=js"
import style0 from "./RightPartMessage.vue?vue&type=style&index=0&id=5a77a852&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a77a852",
  null
  
)

export default component.exports